import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WhatsappNumbersResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappNumbersResponseDataSchema>>

const queryKey = ["whatsappNumbers"]

export const whatsappNumbersQuery = ({
  onSuccess,
}: { onSuccess?: (data: Response["data"]) => void } = {}) => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/whatsapp/numbers`)

      onSuccess?.(response.data.data)
      return response.data.data
    },
  })
}
